function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React from "react";
import { withRouter } from "react-router";
import PubSub from "pubsub-js";
import { CssContainer, Container } from "../../components/container";
import { Loader } from "../../components/loaders";
import Auth from "../../functions/authenticate";
import { Button } from "@progress/kendo-react-buttons";
import PlunkDropDown from "../../components/plunk-dropdown";
import RangePicker from "../../components/range-picker";
import SiteActivityTabs from "../../components/site-activity-tabs";
import WebActivityHeader from "../web-activity/header";
import ServiceFactory from "../../service";
import { RANGES } from "../sales/territory-common";
import { emailSvc } from "../email-automation/common";
import { getGlobalRange, subscribePeriod, unsubscribePeriod } from "../../functions/period-store";

/*
 * §291 — Journey Analytics Phase A: visual acquisition funnels.
 * Site Activity → Funnels. Backend: /v1/activity/funnels (CRUD + results;
 * contract probed 2026-08-31 — see the §291 build status).
 *
 * Semantics the copy must state (spec A.2): sessions enter at step 1
 * only, steps count in order, gaps allowed. Results build NIGHTLY — an
 * active funnel with no day rows yet shows "building", never zeros
 * presented as truth. Bot rows and non-allowlisted hosts are excluded
 * upstream.
 *
 * Step vocabulary: type "path" (exact|prefix) or "event" — event names
 * come from the same trigger catalog the §283 automation picker uses
 * (GET /v1/campaign/email/triggers), free text allowed for events that
 * haven't fired yet.
 *
 * Segment shape defensive note: results.segments came back null on every
 * probe (no populated tenant reachable from here) — the renderer maps
 * tolerantly and hides the row when it can't read the shape.
 */

const funnelSvc = api => {
  const S = ServiceFactory.getType(`/funnels${api || ""}`, "activity");
  return new S();
};
const num = v => (Number(v) || 0).toLocaleString("en-US");
const parseSteps = f => {
  try {
    return JSON.parse(f.stepsJson || "[]") || [];
  } catch (e) {
    return [];
  }
};
const blankStep = () => ({
  label: "",
  type: "path",
  match: "",
  matchMode: "exact"
});
class FunnelsViewComponent extends React.Component {
  constructor(props) {
    super(props);
    _defineProperty(this, "loadList", async preferId => {
      try {
        const all = await funnelSvc("").getAsync();
        if (!this._alive) return;
        const rows = (Array.isArray(all) ? all : []).filter(f => f.status !== "archived");
        const selId = preferId || this.state.selId;
        const sel = rows.find(f => f.id === selId) || rows[0] || null;
        this.setState({
          funnels: rows,
          selId: sel ? sel.id : null
        }, () => this.fetchResults());
      } catch (e) {
        if (this._alive) this.setState({
          funnels: [],
          error: "Could not load funnels."
        });
      }
    });
    _defineProperty(this, "fetchResults", async () => {
      const {
        selId,
        segment
      } = this.state;
      if (!selId) {
        this.setState({
          results: null
        });
        return;
      }
      const key = `${selId}|${this.range()}|${segment}`;
      this.setState({
        loadingResults: true
      });
      try {
        const q = segment !== "none" ? `?segment=${segment}` : "";
        const r = await funnelSvc(`/${selId}/results/${this.range()}${q}`).getAsync();
        if (this._alive) this.setState({
          results: r || null,
          resultsFor: key,
          loadingResults: false
        });
      } catch (e) {
        if (this._alive) this.setState({
          results: null,
          resultsFor: key,
          loadingResults: false,
          error: "Could not load funnel results."
        });
      }
    });
    _defineProperty(this, "setRange", token => {
      const {
        selId
      } = this.state;
      this.props.history.push(`/Activity/Funnels/${token}${selId ? `/${selId}` : ""}`);
    });
    _defineProperty(this, "selectFunnel", id => {
      if (id === "__new") {
        this.openEditor(null);
        return;
      }
      this.setState({
        selId: id,
        results: null,
        error: null
      }, () => this.fetchResults());
    });
    // ---- Activate / archive (server-truth verified — the §288.3 lesson) ----
    _defineProperty(this, "setStatus", async status => {
      const {
        selId
      } = this.state;
      if (!selId) return;
      this.setState({
        busy: true,
        error: null,
        confirmArchive: false
      });
      try {
        await funnelSvc(`/${selId}/status?status=${status}`).putAsync({});
        const all = await funnelSvc("").getAsync();
        const row = (Array.isArray(all) ? all : []).find(f => f.id === selId);
        const persisted = row ? row.status : "?";
        if (!this._alive) return;
        if (persisted !== status) {
          this.setState({
            busy: false,
            error: `The status change didn't stick — the funnel is still ${persisted}. Try again.`
          });
          return;
        }
        this.setState({
          busy: false
        });
        this.loadList(status === "archived" ? null : selId);
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          error: "The status change failed — try again."
        });
      }
    });
    // ---- Editor -----------------------------------------------------------
    _defineProperty(this, "openEditor", f => {
      this.setState({
        editor: f ? {
          id: f.id,
          name: f.name || "",
          scope: f.scope || "session",
          host: f.host || "",
          steps: parseSteps(f).map(s => ({
            label: s.label || "",
            type: s.type || "path",
            match: s.match || "",
            matchMode: s.matchMode || "exact"
          }))
        } : {
          id: null,
          name: "",
          scope: "session",
          host: "",
          steps: [blankStep(), blankStep()]
        },
        error: null
      });
    });
    _defineProperty(this, "patchStep", (i, part) => this.setState(st => {
      const steps = st.editor.steps.slice();
      steps[i] = {
        ...steps[i],
        ...part
      };
      return {
        editor: {
          ...st.editor,
          steps
        }
      };
    }));
    _defineProperty(this, "saveEditor", async () => {
      const ed = this.state.editor;
      const steps = ed.steps.map(s => ({
        label: s.label.trim() || s.match.trim(),
        type: s.type,
        match: s.match.trim(),
        ...(s.type === "path" ? {
          matchMode: s.matchMode || "exact"
        } : {})
      }));
      if (!ed.name.trim()) {
        this.setState({
          error: "Name the funnel."
        });
        return;
      }
      if (steps.length < 2 || steps.some(s => !s.match)) {
        this.setState({
          error: "A funnel needs 2–8 steps, each with a page path or event."
        });
        return;
      }
      this.setState({
        busy: true,
        error: null
      });
      const body = {
        name: ed.name.trim(),
        scope: ed.scope,
        host: ed.host.trim() || null,
        stepsJson: JSON.stringify(steps)
      };
      try {
        let id = ed.id;
        if (id) await funnelSvc(`/${id}`).putAsync(body);else {
          const created = await funnelSvc("").postAsync(body);
          id = created && created.id;
        }
        if (!this._alive) return;
        this.setState({
          busy: false,
          editor: null
        });
        this.loadList(id);
      } catch (e) {
        if (this._alive) this.setState({
          busy: false,
          error: "Save failed — try again."
        });
      }
    });
    this.state = {
      funnels: null,
      // list rows (archived filtered client-side)
      selId: props.params.id || null,
      results: null,
      resultsFor: null,
      loadingResults: false,
      mode: "all",
      // all | identified
      segment: "none",
      // none | source | host
      triggers: null,
      // §283 vocabulary for event steps
      editor: null,
      // {id?, name, scope, host, steps[]}
      busy: false,
      error: null,
      confirmArchive: false
    };
    this._alive = true;
  }
  range() {
    return this.props.params.range || getGlobalRange();
  }
  async componentDidMount() {
    this._periodTok = subscribePeriod(({
      range
    }) => {
      if (!this._alive || !range) return;
      const {
        selId
      } = this.state;
      const target = `/Activity/Funnels/${range}${selId ? `/${selId}` : ""}`;
      if (window.location.pathname === target) {
        this.fetchResults();
      } else {
        this.props.history.push(target);
      }
    });
    if (!(Auth.isAuthenticated() || (await Auth.attachOrSignIn()))) return;
    emailSvc("/triggers").getAsync().then(t => this._alive && this.setState({
      triggers: t || null
    })).catch(() => {});
    this.loadList();
  }
  componentWillUnmount() {
    this._alive = false;
    unsubscribePeriod(this._periodTok);
  }
  componentDidUpdate(prev) {
    if (prev.params.range !== this.props.params.range) this.fetchResults();
  }
  // ---- Segment cards (defensive shape mapping — see header note) --------
  segCards(results) {
    const segs = results && results.segments;
    if (!Array.isArray(segs) || !segs.length) return null;
    const cards = segs.map(s => {
      const label = s.value != null ? s.value : s.segmentValue != null ? s.segmentValue : s.segment != null ? s.segment : s.name;
      const raw = s.steps || s.stepSessions || null;
      const nums = Array.isArray(raw) ? raw.map(x => typeof x === "number" ? x : Number(x && x.sessions) || 0) : null;
      if (label == null) return null;
      let leak = null;
      if (nums && nums.length > 1 && nums[0] > 0) {
        let worst = 0,
          at = 0;
        for (let i = 1; i < nums.length; i++) {
          const d = nums[i - 1] > 0 ? 1 - nums[i] / nums[i - 1] : 0;
          if (d > worst) {
            worst = d;
            at = i;
          }
        }
        leak = {
          pct: Math.round(worst * 100),
          from: at,
          total: nums[0]
        };
      }
      return {
        label: String(label),
        leak,
        total: nums && nums[0] || s.sessions || null
      };
    }).filter(Boolean);
    if (!cards.length) return null;
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        marginTop: "14px"
      }
    }, cards.map((c, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        border: "1px solid var(--plk-border)",
        borderRadius: "10px",
        padding: "8px 12px",
        fontSize: "12px",
        background: "var(--plk-surface-alt)"
      }
    }, /*#__PURE__*/React.createElement("b", null, c.label), c.total != null ? /*#__PURE__*/React.createElement("span", {
      style: {
        color: "var(--plk-text-dim)"
      }
    }, " \xB7 ", num(c.total), " sessions") : null, c.leak ? /*#__PURE__*/React.createElement("span", null, " \xB7 biggest leak step ", c.leak.from, "\u2192", c.leak.from + 1, " ", /*#__PURE__*/React.createElement("b", {
      style: {
        color: "#b3383f"
      }
    }, "\u2212", c.leak.pct, "%")) : null)));
  }

  // ---- Funnel bars ------------------------------------------------------
  funnelBars(results) {
    const {
      mode
    } = this.state;
    const steps = results && results.steps || [];
    if (!steps.length) return null;
    const metric = s => mode === "identified" ? Number(s.identifiedPersons) || 0 : Number(s.sessions) || 0;
    const base = metric(steps[0]);
    const parts = [];
    steps.forEach((s, i) => {
      if (i > 0) {
        const prev = metric(steps[i - 1]);
        const cur = metric(s);
        const dropPct = prev > 0 ? Math.round((1 - cur / prev) * 100) : 0;
        parts.push(/*#__PURE__*/React.createElement("div", {
          key: `d${i}`,
          style: {
            width: "72px",
            flex: "none",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            color: "#b3383f",
            fontSize: "12px",
            fontWeight: 700
          }
        }, /*#__PURE__*/React.createElement("span", {
          className: "material-icons",
          style: {
            color: "var(--plk-text-dim)",
            fontSize: "18px"
          }
        }, "arrow_forward"), "\u2212", dropPct, "%", /*#__PURE__*/React.createElement("small", {
          style: {
            color: "var(--plk-text-dim)",
            fontWeight: 400,
            fontSize: "10.5px"
          }
        }, num(prev - cur), " left")));
      }
      const m = metric(s);
      const isLast = i === steps.length - 1;
      const hPct = base > 0 ? Math.max(m / base * 100, m > 0 ? 4 : 2) : 2;
      const isConversion = s.type === "event" && Number(s.conversionValue) > 0;
      parts.push(/*#__PURE__*/React.createElement("div", {
        key: i,
        style: {
          flex: 1,
          minWidth: "148px",
          display: "flex",
          flexDirection: "column"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          height: "180px",
          display: "flex",
          alignItems: "flex-end",
          background: "var(--plk-surface-alt)",
          borderRadius: "10px 10px 0 0",
          position: "relative",
          overflow: "hidden"
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          position: "absolute",
          top: "10px",
          left: 0,
          right: 0,
          textAlign: "center",
          fontSize: "19px",
          fontWeight: 800
        }
      }, num(m), /*#__PURE__*/React.createElement("small", {
        style: {
          display: "block",
          fontSize: "10px",
          fontWeight: 600,
          color: "var(--plk-text-dim)",
          letterSpacing: ".04em"
        }
      }, mode === "identified" ? "IDENTIFIED" : "SESSIONS")), /*#__PURE__*/React.createElement("div", {
        style: {
          width: "100%",
          height: `${hPct}%`,
          borderRadius: "10px 10px 0 0",
          background: isLast && isConversion ? "linear-gradient(180deg,#78d237,#4a9e21)" : "linear-gradient(180deg,#ff6358,#d94f45)"
        }
      })), /*#__PURE__*/React.createElement("div", {
        style: {
          border: "1px solid var(--plk-border)",
          borderTop: "none",
          borderRadius: "0 0 10px 10px",
          padding: "9px 12px"
        }
      }, /*#__PURE__*/React.createElement("b", {
        style: {
          display: "block",
          fontSize: "12.5px"
        }
      }, i + 1, " \xB7 ", s.label || s.match), /*#__PURE__*/React.createElement("span", {
        style: {
          fontSize: "11px",
          color: "var(--plk-text-dim)"
        }
      }, s.type === "event" ? isConversion ? "conversion" : "event" : "page", i === 0 ? " · entry" : "", isLast && results.endToEndPct != null ? ` · ${(Number(results.endToEndPct) || 0).toFixed(1)}% end-to-end` : "", isConversion ? ` · $${num(Math.round(s.conversionValue))} value` : ""))));
    });
    return /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        alignItems: "stretch",
        margin: "12px 0 4px",
        overflowX: "auto",
        paddingBottom: "6px"
      }
    }, parts);
  }

  // ---- Editor render ----------------------------------------------------
  renderEditor() {
    const {
      editor: ed,
      triggers,
      busy
    } = this.state;
    const inputStyle = {
      padding: "7px 9px",
      border: "1px solid var(--plk-border)",
      borderRadius: "6px",
      fontSize: "13px",
      boxSizing: "border-box"
    };
    const labelStyle = {
      fontSize: "11px",
      textTransform: "uppercase",
      letterSpacing: ".05em",
      color: "var(--plk-text-dim)",
      display: "block",
      marginBottom: "3px"
    };
    const events = triggers ? [...(triggers.conversions || []).map(t => [t.name, `${t.name} — conversion`]), ...(triggers.engagements || []).map(t => [t.name, `${t.name} — engagement`])] : [];
    return /*#__PURE__*/React.createElement(Container, {
      title: ed.id ? "Edit funnel steps" : "New funnel",
      css: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "12px",
        flexWrap: "wrap",
        marginBottom: "12px"
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 240px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Funnel name"), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inputStyle,
        width: "100%"
      },
      value: ed.name,
      placeholder: "e.g. Designer campaign funnel",
      onChange: e => this.setState({
        editor: {
          ...ed,
          name: e.target.value
        }
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "0 0 210px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Steps count within"), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "210px",
      value: ed.scope,
      options: [["session", "One session"], ["person_7d", "Same person · 7 days"]],
      onChange: v => this.setState({
        editor: {
          ...ed,
          scope: v
        }
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "0 0 200px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Site (optional)"), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inputStyle,
        width: "100%"
      },
      value: ed.host,
      placeholder: "all sites",
      onChange: e => this.setState({
        editor: {
          ...ed,
          host: e.target.value
        }
      })
    }))), ed.steps.map((s, i) => /*#__PURE__*/React.createElement("div", {
      key: i,
      style: {
        display: "flex",
        gap: "10px",
        alignItems: "flex-end",
        flexWrap: "wrap",
        marginBottom: "8px"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: "12px",
        fontWeight: 700,
        width: "18px",
        paddingBottom: "8px"
      }
    }, i + 1), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "0 0 150px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Label"), /*#__PURE__*/React.createElement("input", {
      style: {
        ...inputStyle,
        width: "100%"
      },
      value: s.label,
      placeholder: s.type === "path" ? "e.g. Pricing" : "e.g. Signed up",
      onChange: e => this.patchStep(i, {
        label: e.target.value
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "0 0 130px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Step type"), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "130px",
      value: s.type,
      options: [["path", "Page path"], ["event", "Event"]],
      onChange: v => this.patchStep(i, {
        type: v,
        match: ""
      })
    })), /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "1 1 220px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, s.type === "path" ? "Path" : "Event name"), s.type === "event" && events.length ? /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "100%",
      value: events.some(([n]) => n === s.match) ? s.match : s.match ? "__custom" : "",
      options: [["", "Choose an event…"], ...events, ["__custom", "Type a custom event…"]],
      onChange: v => this.patchStep(i, {
        match: v === "__custom" ? s.match || "" : v
      })
    }) : null, s.type === "path" || !events.length || s.type === "event" && s.match && !events.some(([n]) => n === s.match) ? /*#__PURE__*/React.createElement("input", {
      style: {
        ...inputStyle,
        width: "100%",
        marginTop: s.type === "event" && events.length ? "6px" : 0
      },
      value: s.match,
      placeholder: s.type === "path" ? "/pricing" : "Exact event name from your site tracking",
      onChange: e => this.patchStep(i, {
        match: e.target.value
      })
    }) : null), s.type === "path" ? /*#__PURE__*/React.createElement("div", {
      style: {
        flex: "0 0 130px"
      }
    }, /*#__PURE__*/React.createElement("label", {
      style: labelStyle
    }, "Match"), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "130px",
      value: s.matchMode,
      options: [["exact", "Exact"], ["prefix", "Starts with"]],
      onChange: v => this.patchStep(i, {
        matchMode: v
      })
    })) : /*#__PURE__*/React.createElement("span", {
      style: {
        flex: "0 0 130px"
      }
    }), ed.steps.length > 2 && /*#__PURE__*/React.createElement("button", {
      className: "territory-back no-border",
      style: {
        paddingBottom: "6px"
      },
      title: "Remove step",
      onClick: () => this.setState({
        editor: {
          ...ed,
          steps: ed.steps.filter((_, j) => j !== i)
        }
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: "17px"
      }
    }, "close")))), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px",
        alignItems: "center",
        marginTop: "10px"
      }
    }, ed.steps.length < 8 && /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        editor: {
          ...ed,
          steps: [...ed.steps, blankStep()]
        }
      })
    }, "+ Add step"), /*#__PURE__*/React.createElement("span", {
      style: {
        flex: 1
      }
    }), /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setState({
        editor: null,
        error: null
      })
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: this.saveEditor
    }, busy ? "Saving…" : ed.id ? "Save steps" : "Save as draft")), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "10px 0 0"
      }
    }, "Sessions enter at step 1 only; steps count in order, gaps allowed. ", ed.id ? "Editing an active funnel resets its results — they rebuild from history on the next nightly run." : "New funnels save as drafts — activate when the steps are right; results build nightly."));
  }
  render() {
    const {
      funnels,
      selId,
      results,
      loadingResults,
      mode,
      segment,
      editor,
      busy,
      error,
      confirmArchive
    } = this.state;
    if (funnels === null) return /*#__PURE__*/React.createElement(Loader, null);
    const sel = funnels.find(f => f.id === selId) || null;
    const chip = (on, label, onClick) => /*#__PURE__*/React.createElement("a", {
      className: "mtf-chip" + (on ? " on" : ""),
      style: {
        cursor: "pointer"
      },
      onClick: onClick
    }, label);
    const base = results && results.steps && results.steps.length ? Number(results.steps[0].sessions) || 0 : 0;
    const building = sel && sel.status === "active" && results && base === 0;
    return /*#__PURE__*/React.createElement("div", {
      className: "territory-view territory-detail"
    }, /*#__PURE__*/React.createElement("div", {
      className: "wa-view"
    }, /*#__PURE__*/React.createElement(WebActivityHeader, {
      range: this.range()
    })), /*#__PURE__*/React.createElement(SiteActivityTabs, {
      range: this.range()
    }), error && /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: 0,
        color: "#b3383f"
      }
    }, error)), editor ? this.renderEditor() : !funnels.length ? /*#__PURE__*/React.createElement(CssContainer, {
      cls: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("p", {
      className: "module-empty",
      style: {
        marginBottom: "10px"
      }
    }, "No funnels yet \u2014 define the path you expect visitors to take (pages and events, in order) and see exactly where they leave. Results build nightly."), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px"
      }
    }, /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      onClick: () => this.openEditor(null)
    }, "+ New funnel"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => PubSub.publish("plunk-assistant-toggle", {})
    }, "\uD83D\uDCAC Ask Plunk to draft one")), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "10px 0 0"
      }
    }, "Ask Plunk can draft a funnel from your real top paths and events (\"suggest a funnel for our signup flow\") \u2014 you confirm the steps; activation stays yours.")) : /*#__PURE__*/React.createElement(Container, {
      title: "Funnels",
      css: "margin-squeeze"
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        gap: "8px",
        flexWrap: "wrap",
        alignItems: "center",
        marginBottom: "6px"
      }
    }, /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "260px",
      value: selId || "",
      options: [...funnels.map(f => [f.id, f.name]), ["__new", "+ New funnel…"]],
      onChange: this.selectFunnel
    }), sel && /*#__PURE__*/React.createElement("span", {
      className: "cust-stage",
      style: sel.status === "active" ? {
        background: "#e5f3ec",
        color: "#217a4b"
      } : {
        background: "var(--plk-surface-alt)",
        color: "var(--plk-text-dim)"
      }
    }, sel.status), /*#__PURE__*/React.createElement("span", {
      style: {
        width: "6px"
      }
    }), chip(mode === "all", "All sessions", () => this.setState({
      mode: "all"
    })), chip(mode === "identified", "Identified only", () => this.setState({
      mode: "identified"
    })), /*#__PURE__*/React.createElement(PlunkDropDown, {
      width: "160px",
      value: segment,
      options: [["none", "Segment: none"], ["source", "By source"], ["host", "By site (host)"]],
      onChange: v => this.setState({
        segment: v
      }, () => this.fetchResults())
    }), /*#__PURE__*/React.createElement("span", {
      style: {
        marginLeft: "auto",
        display: "flex",
        gap: "8px",
        alignItems: "center"
      }
    }, sel && sel.status === "draft" && /*#__PURE__*/React.createElement(Button, {
      themeColor: "primary",
      disabled: busy,
      onClick: () => this.setStatus("active")
    }, busy ? "Saving…" : "Activate"), sel && /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.openEditor(sel)
    }, "Edit steps"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => PubSub.publish("plunk-assistant-toggle", {})
    }, "\uD83D\uDCAC Ask Plunk"), sel && (confirmArchive ? /*#__PURE__*/React.createElement("span", {
      style: {
        display: "flex",
        gap: "6px",
        alignItems: "center",
        fontSize: "12px"
      }
    }, "Archive this funnel?", /*#__PURE__*/React.createElement(Button, {
      disabled: busy,
      onClick: () => this.setStatus("archived")
    }, "Yes"), /*#__PURE__*/React.createElement(Button, {
      onClick: () => this.setState({
        confirmArchive: false
      })
    }, "No")) : /*#__PURE__*/React.createElement("button", {
      className: "territory-back no-border",
      title: "Archive funnel",
      onClick: () => this.setState({
        confirmArchive: true
      })
    }, /*#__PURE__*/React.createElement("span", {
      className: "material-icons",
      style: {
        fontSize: "17px"
      }
    }, "archive"))))), /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "0 0 4px"
      }
    }, "Sessions enter at step 1 only \xB7 steps in order, gaps allowed \xB7 bot traffic excluded."), sel && sel.status === "draft" && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "8px 0 0",
        color: "#9a6b15"
      }
    }, "Draft \u2014 activate to start collecting. Results build nightly, so first numbers appear the day after activation."), building && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "8px 0 0"
      }
    }, "Building \u2014 this funnel is active and results compute nightly. First numbers appear after the next overnight run (or no sessions matched step 1 in this range yet)."), loadingResults ? /*#__PURE__*/React.createElement(Loader, null) : results ? /*#__PURE__*/React.createElement(React.Fragment, null, this.funnelBars(results), this.segCards(results), segment !== "none" && !this.segCards(results) && base > 0 && /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "8px 0 0"
      }
    }, "No segment breakdown for this range yet.")) : null, /*#__PURE__*/React.createElement("p", {
      className: "territory-hint",
      style: {
        margin: "14px 0 0",
        color: "var(--plk-text-dim)"
      }
    }, "Ask Plunk can draft a funnel from your real top paths and events \u2014 you confirm the steps, activation stays yours. Value shows on steps matching a conversion that carries price value.")));
  }
}
export default withRouter(FunnelsViewComponent);